lmApp
  .service('GroupService' ,['$q', '$rootScope',
    function ($q, $rootScope) {
      var service = {};

      service.GetGroups = function () {
        var deferred = $q.defer();

        var url = 'collection/principal.group/query' + '?t=' + Date.now();

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetGroupsByIds = function (ids) {
        var deferred = $q.defer();

        var url = 'collection/principal.group/query/dimension/id/in/' + ids.join(',') + '?t=' + Date.now();

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.CreateGroup = function (ext_id, group, parnt) {
        var deferred = $q.defer();

        var url = 'principal/mgmt/group/create';

        var data = {
          ext_id: ext_id,
          name: group._PrivateData.title
        };

        if (parnt) {
          data.parent_id = parnt.id;
        }

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.UpdateGroup = function (group, parnt) {
        var deferred = $q.defer();

        var url = 'principal/mgmt/group/update';

        var data = {
          group_id: group.id,
          name: group._PrivateData.name
        };

        if (parnt) {
          data.parent_id = parnt.id;
        }

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.AddPrincipal = function (groups_ids, users_ids) {
        var deferred = $q.defer();

        var url = 'principal/mgmt/group/assoc';

        var data = {
          group_id: groups_ids.join(','),
          principal_id: users_ids.join(',')
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.RemovePrincipal = function (groups_ids, users_ids) {
        var deferred = $q.defer();

        var url = 'principal/mgmt/group/deassoc';

        var data = {
          group_id: groups_ids.join(','),
          principal_id: users_ids.join(',')
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.AddAsset = function (groups_ids, asset_ids) {
        var deferred = $q.defer();

        var url = 'asset/mgmt/group/assoc';

        var data = {
          group_id: groups_ids.join(','),
          asset_id: asset_ids.join(',')
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.RemoveAsset = function (groups_ids, asset_ids) {
        var deferred = $q.defer();

        var url = 'asset/mgmt/group/deassoc';

        var data = {
          group_id: groups_ids.join(','),
          asset_id: asset_ids.join(',')
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.AddOffer = function (groups_ids, offer_ids) {
        var deferred = $q.defer();

        var url = 'offer/mgmt/group/assoc';

        var data = {
          group_id: groups_ids.join(','),
          offer_id: offer_ids.join(',')
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.RemoveOffer = function (groups_ids, offer_ids) {
        var deferred = $q.defer();

        var url = 'offer/mgmt/group/deassoc';

        var data = {
          group_id: groups_ids.join(','),
          offer_id: offer_ids.join(',')
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      return service;
    }]);
